import React, { useState} from 'react'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import fondo from '../../Web Mundo/fondoInicio.png'
import { Button, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { signin } from '../../keychain/login';
import { login, setInformacion } from '../../storage/slices/usuarios';
import { rutas } from '../../rutas/rutas';
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

//const fondo = 'https://res.cloudinary.com/dbav8xw6s/image/upload/v1666558969/hueso/assets/VARIADAS/fondo_inicio_prbywq.png'
export const Login = () => {
  const [ usuario , setUsuario ] = useState('')
  const [password , setPassword ] = useState('')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const parametros = useParams()
  const [open, setOpen] = useState(false);


  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  const handleForm = (e) =>{
    setUsuario(e.target.value)
  }
  useEffect(()=>{
    // fetch(`${URL_MAIN}/api`).then(res=>{
    //   console.log(res)
    //   if(res?.status === 200){
    //     setServer(true)
    //   }
    // })
    //.catch(err=>console.log(err))
  },[])
  const handleLogin = (infoUser) =>{
    
    if(usuario === '' || usuario.length < 3 ){
      handleClick()
      return
    }

    dispatch(
      login({  
          user: usuario
      })
    )
   dispatch(setInformacion(infoUser?.resultado));
    navigate('/game', {
      replace:true
    })
  }
  const handleLoginPass = () => {
    if(usuario.length < 4 || usuario.length > 19 || password.length < 4 || password.length > 15)return   handleClick()
    axios.post(rutas.loginPass,{user: usuario, password:password}).
    then(res=>{
      const token = res.data?.token
      document.cookie = `token=${token}; max-age=${3600 * 12}; path=/; samesite=strict;secure;`
      handleLogin(res.data)
    }).
    catch(err=>  handleClick())
  }
const styleContainer = {
    width: '100%',
    height: '100vh',
    display:'flex',
    justifyContent:'center',
    alignItems: 'center',

}
const styleCard = {
    width: '450px',
    height: '450px',
    display:'flex ',
    justifyContent:'center' ,
    alignItems: 'center',
    flexDirection:'column' ,
    background: 'rgba(106, 175, 255, 0.2)'
}

  return (
    <Box sx={{height: '100%', width: '100%',backgroundImage: `url(${fondo})`, backgroundSize: 'cover' }}> 
    <Box sx={styleContainer}>
      <Box sx={styleCard}>
        <Box
          component="form"
          sx={{
            height: "70%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "column",
           
          }}
          noValidate
          autoComplete="off"
        >
    
          <Typography variant="h5" sx={{textAlign: 'center', color: 'white'}}>Login with your user </Typography>
          <TextField sx={{ color: 'white'}} onChange={handleForm} label="Username" variant="outlined" />
          <TextField type="password" onChange={(e)=> setPassword(e.target.value)} label="Password" variant="outlined" />
          <Box
            sx={{
              width: "90%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button onClick={handleLoginPass} variant="contained">
            Log in
            </Button>
            <Button onClick={()=> {
                signin(usuario, handleLogin, parametros)
            }} variant="contained">KeyChain</Button>
          </Box>
          {/* <iframe src="https://kod.up.railway.app/"></iframe> */}
        </Box>
        <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert
              onClose={handleClose}
              severity="error"
              sx={{ width: "100%" }}
            >
 There was an error loading the data            </Alert>
          </Snackbar>
        </Stack>
      </Box>
    </Box>
    </Box>
  );

}


